import axios, { AxiosError } from 'axios';
import queryClient from '../queryClient';
import * as contragent from './contragent';
import * as dict from './dict';
import * as feature from './feature';
import * as feedback from './feedback';
import * as serviceCenters from './serviceCenters';
import * as system from './system';
import * as user from './user';
import * as phone from './phone';
import * as payment from './payment';

axios.defaults.baseURL = process.env?.REACT_APP_BASE_URL;

axios.interceptors.request.use(async (config) => {
 const token = localStorage.getItem('token');
 const linkshorterToken = localStorage.getItem('linkshorterToken');

 let bearer = token;

 if (config && config.url && config.url.indexOf('linkshorter') !== -1) {
  bearer = linkshorterToken;
 }

 if (bearer) config.headers.Authorization = `Bearer ${bearer}`;
 return config;
});

axios.interceptors.response.use(
 (res) => {
  if (res.config.responseType === 'blob') return res;
  if (res.data?.status === 'error') {
   const errorArray = [
    100210, 100212, 100213, 100214, 100215, 100216, 100217, 100218, 100219,
    100220,
   ];
   if (errorArray.includes(res.data?.errors?.[0]?.code)) {
    return Promise.reject(res.data?.errors?.[0]?.code?.toString());
   }
   return Promise.reject(
    res.data?.errors?.[0]?.error || 'Произошла неизвестная ошибка',
   );
  }

  // const availability = localStorage.getItem('passAvailability');
  // if (availability && availability === '0') {
  //  srv.getAisAvailable().then((response: any) => {
  //   const aisAvailableData = response;
  //   aisAvailableData && aisAvailableData.isAvailable
  //    ? localStorage.setItem('passAvailability', '0')
  //    : localStorage.setItem('passAvailability', '1');
  //  });
  // }

  // const availabilityData = localStorage.getItem('passAvailability');
  // if (availabilityData && availabilityData === '1') {
  //  const data = window.location.href;
  //  window.location.assign(data);
  // }

  return {
   ...res,
   data: res.data?.response ?? null,
   statusText: res.data?.messages?.[0] ?? '',
  };
 },
 (err: AxiosError) => {
  const token = localStorage.getItem('token');

  if (err.response?.status === 401 && !!token) {
   localStorage.removeItem('token');
   queryClient.resetQueries('user');
   queryClient.clear();
  }

  return Promise.reject(err.message);
 },
);

const srv = {
 ...contragent,
 ...dict,
 ...feature,
 ...feedback,
 ...serviceCenters,
 ...system,
 ...user,
 ...phone,
 ...payment,
};

export default srv;
